import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useLocation } from '../../../../shared/router/useLocation';
import { ITranslationFunction } from '../../../../shared/i18n/translate';

export const useGetFromTierRedirectLink = (t: ITranslationFunction) => {
	let redirectLink;
	let redirectLabel;
	const { pathname } = useLocation();
	const royaltyProgramUrl = useUrlForPageId(PassengersPageId.RoyaltyProgram);
	const rewardOffersUrl = useUrlForPageId(PassengersPageId.RewardOffers);

	if (pathname.includes('offers')) {
		redirectLink = royaltyProgramUrl;
		redirectLabel = t('loyalty_royalty_program_label');
	} else {
		redirectLink = rewardOffersUrl;
		redirectLabel = t('loyalty_reward_offers_label');
	}

	return { redirectLink, redirectLabel };
};
